/**
 * Check if element(s) exists, 
 * @param  {Function} cb [description]
 * @return {[type]}      [description]
 */
// export function exists(selector) {
export default function (selector) {
  return qsa(selector).length > 0
};